<template>
    <div class="position-relative">
        <v-app class="p-4">
            <div class="p-0 pt-5 mt-5 col-md-8 mx-auto" style="border: none!important;">
                <p class="mt-5">بسته موردنظر خود را با پرکردن تمامی فیلدهای درخواستی ایجاد کنید.</p>
                <v-row class="mt-5">
                    <v-col cols="12" md="6">
                        <v-autocomplete
                                v-model="type"
                                :items="tarefeList"
                                label="نوع تعرفه"
                                required
                                dense
                                item-text="name"
                                item-value="value"
                                outlined
                                class="mt-1"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="title"
                                label="عنوان تعرفه"
                                required
                                dense
                                outlined
                                class="mt-1"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="price"
                                label="قیمت تعرفه"
                                outlined
                                required
                                dense
                                type="number"
                                class="mt-1"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <div class="col-md-12 text-left">
                    <v-btn class="float-left submit-btn" @click="createTarefe">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت تعرفه</v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
    name: "createTarefe",
    components: {ButtonTempl, TitleRibbon},
    data() {
        return {
            price: '',
            title: '',
            type: '',
            tarefeList: [
                {
                    name: 'تعرفه چت', value: 'chat',
                },
                {
                    name: 'تعرفه تازه های دیوار', value: 'new',
                },
                {
                    name: 'تعرفه مترادف', value: 'unique',
                },
                 {
                    name: 'تعرفه حمله', value: 'report',
                },

            ]
        }
    },
    methods: {
        createTarefe: function () {
            $.ajax({
                url: `${url}/admin/packs/other`,
                type: 'POST',
                fn: this.createTarefe,
                headers: {
                    ACCEPT: 'application/json',
                    AUTHORIZATION: Token,
                },
                data: {
                    title: this.title,
                    price: this.price,
                    type: this.type
                },
                msg: true,
                redirect: {path: '/admin/tarefe/otherTarefe'}
            })
        }
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 1.3rem !important;
}
</style>